import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import {DialogTitle} from '@material-ui/core';

import './DeleteDialog.scss';

export interface ConfirmDialogProps {
    text: string;
    onClose: () => void;
    onConfirm: () => void;
    cancelText?: string
    confirmText?: string;
    secondaryText?: string;
    additionalClassName?: string;
}

export default function ConfirmDialog(props: ConfirmDialogProps) {
    const {
        text,
        onClose,
        onConfirm,
        cancelText,
        confirmText,
        secondaryText,
        additionalClassName,
    } = props;
    
    return (
        <Dialog
            open
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            className={`confirm-dialog ${additionalClassName}`}
        >
            <DialogTitle>
                <DialogContentText
                    id="confirm-dialog-description"
                    variant="h5"
                    color="textPrimary"
                >
                    <span className="confirm-dialog__text confirm-dialog__text_main">
                        {text}
                    </span>
                    <span className="confirm-dialog__text confirm-dialog__text_secondary">
                        {secondaryText}
                    </span>
                </DialogContentText>
            </DialogTitle>
            <DialogActions>
                <Button
                    onClick={onClose}
                >
                    {cancelText || 'No, keep it'}
                </Button>
                <Button
                    onClick={onConfirm}
                    className="confirm-button"
                    autoFocus
                >
                    {confirmText || 'Yes, delete it'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
